// extracted by mini-css-extract-plugin
module.exports = {"Select-animation-fadeIn":"VQtUL","Select-animation-spin":"qjFxW","roll":"gmnLi"};